import { render, staticRenderFns } from "./add.vue?vue&type=template&id=34205538&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34205538",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34205538')) {
      api.createRecord('34205538', component.options)
    } else {
      api.reload('34205538', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=34205538&scoped=true", function () {
      api.rerender('34205538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/synchronization/add.vue"
export default component.exports